import type { ReactNode } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

type ExternalLinkProps = {
  children?: ReactNode;
  className?: string;
  href: string;
  isRouterLink?: boolean;
  state?: any;
};

const NativeLink = ({ href, children, className }: ExternalLinkProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cx('text-primary-600 underline', className)}
    >
      {children}
    </a>
  );
};

const RouterLink = ({ href, children, state }: ExternalLinkProps) => {
  return (
    <Link to={href} state={state} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
};

export const ExternalLink = ({
  href,
  children,
  isRouterLink = false,
  className,
}: ExternalLinkProps) => {
  const hasProtocol = /^https?:\/\//i.test(href);
  const absoluteLink = hasProtocol ? href : `https://${href}`;

  return isRouterLink ? (
    <RouterLink href={href} className={className}>
      {children}
    </RouterLink>
  ) : (
    <NativeLink href={absoluteLink} className={className}>
      {children}
    </NativeLink>
  );
};
